// Function to update mega menu position based on full header height
function updateMegaMenuPosition() {
  // Try multiple header selectors
  const header = document.querySelector('.header-wrapper') || 
                 document.querySelector('.header-nav') || 
                 document.querySelector('header');
  const megaMenus = document.querySelectorAll('.mega-menu-overlay');

  if (header && megaMenus.length > 0) {
  } else {
  }
}

// Simple initialization for mega menu
document.addEventListener('DOMContentLoaded', function() {
  const megaMenuItems = document.querySelectorAll('.has-mega-menu');

  // Mobile menu functionality
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');
  const mobileSubmenuItems = document.querySelectorAll('.mobile-nav-item.has-submenu');

  // Mobile search bar functionality
  const mobileSearchToggle = document.querySelector('.mobile-search-toggle');
  const mobileSearchBar = document.querySelector('.mobile-search-bar');
  const mobileSearchInput = document.querySelector('#mobile-search-input');

  // Toggle mobile menu
  if (mobileMenuToggle && mobileMenuOverlay) {
    mobileMenuToggle.addEventListener('click', function() {
      mobileMenuOverlay.classList.add('active');
      mobileMenuToggle.classList.add('active');
      
      // Prevent body scrolling
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
      
      // Ensure header is visible when mobile menu opens
      const headerWrapper = document.querySelector('.site-header-wrapper');
      if (headerWrapper) {
        headerWrapper.classList.remove('header-hidden');
        headerWrapper.classList.add('header-visible');
      }
    });
  }

  // Close mobile menu
  if (mobileMenuClose && mobileMenuOverlay) {
    mobileMenuClose.addEventListener('click', function() {
      mobileMenuOverlay.classList.remove('active');
      mobileMenuToggle.classList.remove('active');
      
      // Restore body scrolling
      const scrollY = document.body.style.top;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
      
      // Allow header to resume normal scroll behavior after menu closes
      // Don't force header state here - let the scroll handler manage it
    });
  }

  // Close mobile menu when clicking overlay
  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', function(e) {
      if (e.target === mobileMenuOverlay) {
        mobileMenuOverlay.classList.remove('active');
        mobileMenuToggle.classList.remove('active');
        
        // Restore body scrolling
        const scrollY = document.body.style.top;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        
        // Allow header to resume normal scroll behavior after menu closes
        // Don't force header state here - let the scroll handler manage it
      }
    });
  }

  // Toggle mobile search bar
  if (mobileSearchToggle && mobileSearchBar) {
    mobileSearchToggle.addEventListener('click', function() {
      mobileSearchBar.classList.toggle('active');
      if (mobileSearchBar.classList.contains('active')) {
        // Focus on search input when search bar appears
        setTimeout(() => {
          if (mobileSearchInput) {
            mobileSearchInput.focus();
          }
        }, 100);
      }
    });
  }

  // Close mobile search bar with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (mobileSearchBar && mobileSearchBar.classList.contains('active')) {
        mobileSearchBar.classList.remove('active');
      }
      if (mobileMenuOverlay && mobileMenuOverlay.classList.contains('active')) {
        mobileMenuOverlay.classList.remove('active');
        mobileMenuToggle.classList.remove('active');
        
        // Restore body scrolling
        const scrollY = document.body.style.top;
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
  });

  // Simple mobile menu scrolling behavior
  const mobileNav = document.querySelector('.mobile-nav');
  
  if (mobileNav) {
    // Simple scroll indicators
    function updateScrollIndicators() {
      const scrollTop = mobileNav.scrollTop;
      const scrollHeight = mobileNav.scrollHeight;
      const clientHeight = mobileNav.clientHeight;
      const maxScroll = scrollHeight - clientHeight;
      
      // Show/hide scroll indicators
      if (scrollTop > 20) {
        mobileNav.classList.add('scrollable-top');
      } else {
        mobileNav.classList.remove('scrollable-top');
      }
      
      if (scrollTop < maxScroll - 20) {
        mobileNav.classList.add('scrollable-bottom');
      } else {
        mobileNav.classList.remove('scrollable-bottom');
      }
    }
    
    // Simple scroll handler
    let scrollTimeout;
    mobileNav.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateScrollIndicators, 50);
    }, { passive: true });
    
    // Initial check and update on resize
    updateScrollIndicators();
    window.addEventListener('resize', updateScrollIndicators);
  }

  // Simple submenu accordion functionality
  const mobileSubmenuToggles = document.querySelectorAll('.mobile-submenu-toggle');
  
  mobileSubmenuToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const navItem = this.closest('.mobile-nav-item, .mobile-submenu-item');
      const submenu = navItem.querySelector('.mobile-submenu, .mobile-submenu-level-2');
      const isActive = navItem.classList.contains('active');
      
      // Close all other submenus at the same level
      const siblings = navItem.parentElement.children;
      Array.from(siblings).forEach(sibling => {
        if (sibling !== navItem) {
          sibling.classList.remove('active');
          const siblingSubmenu = sibling.querySelector('.mobile-submenu, .mobile-submenu-level-2');
          const siblingToggle = sibling.querySelector('.mobile-submenu-toggle');
          if (siblingSubmenu) siblingSubmenu.classList.remove('active');
          if (siblingToggle) siblingToggle.classList.remove('active');
        }
      });
      
      // Toggle current submenu
      if (isActive) {
        navItem.classList.remove('active');
        submenu.classList.remove('active');
        this.classList.remove('active');
      } else {
        navItem.classList.add('active');
        submenu.classList.add('active');
        this.classList.add('active');
      }
      
      // Update scroll indicators after animation
      if (mobileNav) {
        setTimeout(() => {
          const event = new Event('scroll');
          mobileNav.dispatchEvent(event);
        }, 350);
      }
    });
  });
});
